import React from 'react'
import Hotel from '../../ui/views/Hotel/Hotel'

const HotelRoute = () => {
  return (
    <Hotel/>
  )
}

export default HotelRoute